var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8005 3.70699C12.4108 -0.00151675 7.51719 -1.10033 3.73263 1.20031C0.0395392 3.50096 -1.14957 8.51431 1.24008 12.2114L1.43445 12.509L0.634092 15.5078L3.62973 14.7066L3.927 14.9012C5.21901 15.5994 6.62536 16 8.02028 16C9.51809 16 11.0159 15.5994 12.3079 14.7982C16.001 12.3945 17.0986 7.48417 14.8005 3.6841V3.70699ZM12.7081 11.4216C12.3079 12.0168 11.8048 12.4174 11.1074 12.5204C10.7072 12.5204 10.2041 12.715 8.21465 11.9252C6.52246 11.124 5.11611 9.81916 4.12138 8.31973C3.52682 7.62152 3.21811 6.71729 3.12664 5.81306C3.12664 5.01183 3.42392 4.31363 3.927 3.81C4.12138 3.61542 4.32718 3.51241 4.52156 3.51241H5.02464C5.21901 3.51241 5.42482 3.51241 5.52772 3.91302C5.7221 4.41664 6.22518 5.61847 6.22518 5.72149C6.32808 5.8245 6.28235 6.59138 5.825 7.02633C5.57346 7.31248 5.52772 7.32393 5.63063 7.52996C6.03081 8.12515 6.53389 8.73179 7.02554 9.23541C7.6201 9.73903 8.22608 10.1396 8.92354 10.4372C9.11791 10.5403 9.32372 10.5403 9.42662 10.3342C9.52953 10.1396 10.0212 9.63602 10.227 9.42999C10.4214 9.23541 10.5243 9.23541 10.7301 9.32698L12.3308 10.1282C12.5252 10.2312 12.731 10.3228 12.8339 10.4258C12.9368 10.7234 12.9368 11.124 12.731 11.4216H12.7081Z",
    fill: "#4776E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.0fe26a4d107e7eb83698424ae6e4dc90.svg";
export { ForwardRef as ReactComponent };